import { Accordion } from "@/components/ui/Accordion";

/**
 * FAQSection Component
 * Frequently asked questions accordion
 */
export function FAQSection({ faqs }) {
  return (
    <section
      id="faq"
      className="py-16 px-8 pb-20 bg-accent-bg max-md:py-8 max-md:px-4"
    >
      {/* Header */}
      <h2
        className="font-family-title text-[2.5rem] font-normal text-center mb-2
                     max-md:text-[1.8rem] max-md:leading-[1.25] max-md:mb-2"
      >
        Questions? We've got answers.
      </h2>
      <p
        className="text-[1.1rem] text-gray text-center mb-8 max-w-[500px] mx-auto leading-relaxed
                    max-md:text-[0.95rem] max-md:mb-6"
      >
        Find quick answers to the most common questions about Naori.
      </p>
      {/* FAQ Accordion */}
      <Accordion items={faqs} allowMultiple={false} className="max-md:gap-2" />
    </section>
  );
}

export default FAQSection;
